<nav class="navbar navbar-light bg-light navbar-expand-lg">
    <form class="form-inline flex-fill" id="formularioFiltros">
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>
        <ul class="navbar-nav ms-2 me-auto">
            <!--buscador -->
            <li class="nav-item me-2">
                <div class="nav-item">
                    <input id="busquedaFormControl" type="text" class="form-control" placeholder="Buscador"
                        [formControl]="busquedaFormControl" (input)="aplicarFiltros()"/>
                </div>
            </li>

            <div class="nav-item">
                <div ngbDropdown autoClose="outside">
                    <button class="btn btn-outline-primary my-2 my-lg-0 mx-lg-2" id="dropdownTransportistas"
                        ngbDropdownToggle>Transportistas</button>
                    <div ngbDropdownMenu aria-labelledby="dropdownTransportistas">
                        <div class="px-4 py-3">
                            <div *ngFor="let transportista of transportistas">
                                <div class="form-check">
                                    <input type="checkbox" class="form-check-input"
                                        id="{{ 'dropdownCheck' + transportista.nombre}}"
                                        [(ngModel)]="transportista.seleccionado" name="{{transportista.nombre}}"
                                        (change)="aplicarFiltros()">
                                    <label class="form-check-label text-nowrap"
                                        for="{{ 'dropdownCheck' + transportista.nombre}}">
                                        {{ transportista.nombre}}
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="nav-item">
                <div ngbDropdown autoClose="outside">
                    <button class="btn btn-outline-primary my-2 my-lg-0 mx-lg-2" id="dropdownEstados"
                        ngbDropdownToggle>Estados</button>
                    <div ngbDropdownMenu aria-labelledby="dropdownEstados">
                        <div class="px-4 py-3">
                            <div *ngFor="let estado of estados">
                                <div class="form-check">
                                    <input type="checkbox" class="form-check-input"
                                        id="{{ 'dropdownCheck' + estado.nombre}}" [(ngModel)]="estado.seleccionado"
                                        name="{{estado.nombre}}" (change)="aplicarFiltros()">
                                    <label class="form-check-label text-nowrap"
                                        for="{{ 'dropdownCheck' + estado.nombre}}">
                                        {{ estado.nombre}}
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <li class="nav-item me-2">
                <div class="input-group">
                    <input type="date" [ngModel]="modelDesde" class="fechaFormControlDesdeHasta"
                        placeholder="aaaa-mm-dd" (ngModelChange)="modelDesde = $event" name="dt" ngbDatepicker
                        #d="ngbDatepicker" value="model" class="form-control form-control-rounded" #id="ngbDatepicker"
                        #searchDate required readonly>

                    <div class="input-group-append">
                        <button id="botonDesde" type="button" class="input-group-btn btn btn-secondary"
                            (click)="toggleDatepicker(d)">
                            <i class="fa fa-calendar" aria-hidden="true"></i>
                        </button>
                    </div>
                </div>
            </li>

            <li class="nav-item me-2">
                <div class="input-group">
                    <input type="date" [ngModel]="modelHasta" class="fechaFormControlDesdeHasta"
                        placeholder="aaaa-mm-dd" (ngModelChange)="modelHasta = $event" name="dt" ngbDatepicker
                        #h="ngbDatepicker" value="model" class="form-control form-control-rounded" #id="ngbDatepicker"
                        #searchDate required readonly>

                    <div class="input-group-append">
                        <button id="botonDesde" type="button" class="input-group-btn btn btn-secondary"
                            (click)="toggleDatepicker(h)">
                            <i class="fa fa-calendar" aria-hidden="true"></i>
                        </button>
                    </div>
                </div>
            </li>

            <li class="nav-item me-2">
                <button (click)="obtenerRemitos()" class="btn btn-outline-primary my-2 my-lg-0 mx-lg-2">
                    <i class="fa fa-search" aria-hidden="true"></i>
                </button>
            </li>

        </ul>
    </form>
</nav>

<div class="mt-1 col container-fluid">
    <div class="spinner-container" *ngIf="loading">
        <ngx-spinner name="spinnerLista" bdOpacity=0.3bd Color="rgba(193,193,193,0)" size="medium" color="#185db5"
            type="ball-grid-beat" [fullScreen]="false">
            <p style="color: white"> C a r g a n d o . . . </p>
        </ngx-spinner>
    </div>

    <ngb-alert [dismissible]="false" *ngIf="!loading && remitosFiltrados.length==0">
        No existen movimientos para la busqueda seleccionada
    </ngb-alert>

    <div *ngIf="!loading && remitosFiltrados.length > 0" class="table-responsive">
        <table class="table table-striped table-hover text-center">
            <thead class="titulo text-center">
                <tr>
                    <th scope="col">Fecha de despacho</th>
                    <th scope="col">Nº de remito</th>
                    <th scope="col">Terminal</th>
                    <th scope="col">Producto</th>
                    <th scope="col">Transportista</th>
                    <th scope="col">Litros a natural</th>
                    <th scope="col">Litros a 15º</th>
                    <th scope="col">Estado</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let r of remitosFiltrados; let i=index">
                    <td>{{r.fechaHoraCreacion | date:'dd/MM/yyyy HH:mm'}}</td>
                    <td>{{r.prefijoRemitoCargamento}}-{{r.numeroRemitoCargamento}}</td>
                    <td>{{r.terminal.nombre}}</td>
                    <td>
                        <button *ngIf="r.detalleProductos?.length > 1" class="btn btn-link p-0 text-dark"
                            (click)="abrirDetalle(r)" ngbTooltip="Ver detalle de productos">
                            <i class="fa fa-eye"></i>
                        </button>
                        <span *ngIf="r.detalleProductos?.length === 1">
                            {{ r.detalleProductos[0]?.nombreProducto }}
                        </span>
                    </td>
                    <td>{{r.detalleCamion?.nombreTransportista}}</td>
                    <td>
                        <button *ngIf="r.detalleProductos?.length > 1" class="btn btn-link p-0 text-dark"
                            (click)="abrirDetalle(r)" ngbTooltip="Ver detalle de productos">
                            <i class="fa fa-eye"></i>
                        </button>
                        <span *ngIf="r.detalleProductos?.length === 1">
                            {{ r.detalleProductos[0]?.cantidad | number:'1.0-3' }}
                        </span>
                    </td>

                    <td>
                        <button *ngIf="r.detalleProductos?.length > 1" class="btn btn-link p-0 text-dark"
                            (click)="abrirDetalle(r)" ngbTooltip="Ver detalle de productos">
                            <i class="fa fa-eye"></i>
                        </button>
                        <span *ngIf="r.detalleProductos?.length === 1">
                            {{ r.detalleProductos[0]?.detalleCombustible.cantidad15 | number:'1.0-3' }}
                        </span>
                    </td>

                    <td>
                        @if (r.estadoRemito === EstadoRemitoCargamento.Pendiente) {
                        <div class="d-inline-flex gap-2">
                            <button (click)="abrirRecepcion(r)" [disabled]="proccess" class="btn btn-primary btn-sm">
                                {{ proccess ? 'Cargando...' : 'Ingresar' }}
                            </button>
                            <button (click)="rechazarRemito(r)" [disabled]="proccess"
                                class="btn btn-outline-danger btn-sm">
                                {{ proccess ? 'Cargando...' : 'Rechazar' }}
                            </button>
                        </div>
                        } @else {
                        <span class="badge bg-secondary">{{ EstadoRemitoCargamento[r.estadoRemito] }}</span>
                        }
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>